import * as graph from '@adc/sdk'
import type { AuctionBlueprintOnlineReactiveArgs } from '@adc/blueprint'
import { match } from 'ts-pattern'

export const getSellerDeedTooltip = (
  listing: AuctionBlueprintOnlineReactiveArgs['listing']
): string => {
  return (listing.program_configuration?.deed_types || [])
    .map((deedType: string | null) =>
      match(deedType)
        .when(
          deedType => deedType === graph.enums.ListingDeedType.WarrantyDeed,
          () =>
            'A General Warranty Deed offers the maximum amount of protection.'
        )
        .when(
          deedType =>
            deedType === graph.enums.ListingDeedType.SpecialWarrantyDeed,
          () =>
            'You will have the option to buy title insurance and receive a Special Warranty Deed.'
        )
        .when(
          deedType => deedType === graph.enums.ListingDeedType.QuitclaimDeed,
          () =>
            'A Quitclaim Deed provides no warranties or covenants to the buyer. Recommended for seasoned investors.'
        )
        .when(
          deedType =>
            deedType === graph.enums.ListingDeedType.QdAssignmentInterest,
          () =>
            "The Seller is assigning their interest in a Sheriff's Deed. A Quitclaim Deed provides no warranties or covenants to the buyer."
        )
        .when(
          deedType => deedType === graph.enums.ListingDeedType.QdAssignmentCert,
          () =>
            "The Seller is assigning their interest in a Sheriff's Certificate. A Quitclaim Deed provides no warranties or covenants to the buyer."
        )
        .when(
          deedType => deedType === graph.enums.ListingDeedType.TrusteeDeed,
          () => 'This deed will be issued by a trustee in a bankruptcy case.'
        )
        .otherwise(() => null)
    )
    .filter(Boolean)
    .join(', ')
}
